<template>
  <path
    v-if="path"
    :class="['area', { hovered: hoveredStacked === serie.key }]"
    :d="
      path +
      (previousPath ||
        `V
  ${this.p.scaleY(this.p.minY)} H ${this.p.scaleX(p.minX)} Z`)
    "
    :fill="
      hoveredStacked === serie.key
        ? 'rgba(255, 255, 255, 0.2)'
        : 'rgba(255, 255, 255, 0.1)'
    "
  />
</template>

<script>
import * as d3Shape from "d3-shape";
import { mapGetters } from "vuex";
export default {
  computed: {
    path() {
      var lineFunction = d3Shape
        .line()
        .x((o) => {
          return this.p.scaleX(o[this.c.xAxis]);
        })
        .y((o) => {
          return this.p.scaleY(o[this.serie.key]);
        })
        .curve(d3Shape[this.c.yAxisCurve]);

      return lineFunction(this.d);
    },
    previousPath() {
      if (!this.previousSerie) return;
      var lineFunction = d3Shape
        .line()
        .x((o) => {
          return this.p.scaleX(o[this.c.xAxis]);
        })
        .y((o) => {
          return this.p.scaleY(o[this.previousSerie.key]);
        })
        .curve(d3Shape[this.c.yAxisCurve]);

      return lineFunction([...this.d].reverse()).replace("M", "L");
    },
    ...mapGetters({ hoveredStacked: "ui/hoveredStacked" }),
  },
  props: ["p", "c", "d", "serie", "previousSerie"],
};
</script>

<style lang="scss" scoped>
.area {
  transition: fill 0.3s ease;
}
</style>
